import { DpOutlinedSelect } from '@/components/blocks/DpOutlineSelect';
import { ProductSizeInput } from '@/components/content/ProductDetails/parts/CompleteLook/style/completeLook';
import { MenuItem, SelectChangeEvent } from '@mui/material';

interface SizeSelectProps {
	value: string;
	sizes: { partNumber: string; size: string }[];
	onChange: (childPartNumber: string) => void;
}

export const SizeSelect = ({ value, sizes, onChange }: SizeSelectProps) => (
	<DpOutlinedSelect
		value={value || 'talla'}
		input={<ProductSizeInput />}
		sx={{
			height: '32px !important',
			'.MuiInputBase-input': {
				height: '32px !important',
				boxSizing: 'border-box',
				display: 'flex',
				alignItems: 'center',
				paddingTop: 0,
				paddingBottom: 0,
			},
			'.MuiSelect-nativeInput': {
				padding: '0px',
			},
		}}
		MenuProps={{
			sx: {
				zIndex: 9999999999,
			},
		}}
		onChange={((event: SelectChangeEvent<string>) => onChange(event.target.value)) as any}
	>
		<MenuItem disabled value="talla">
			{'Talla'}
		</MenuItem>
		{sizes.map((size) => (
			<MenuItem key={size.partNumber} value={size.partNumber}>
				{size.size}
			</MenuItem>
		))}
	</DpOutlinedSelect>
);
